import React, { useContext } from 'react';
import { AppContext } from 'src/components/app-context';
import { CategoryTreeItem } from '../sub-category-map';
import { trackClick, SHOW_ALL_LINK } from '../utils';
import { SubLevelItemShowAll, SubLevelLink } from '../styles';

const CategoryItemShowAll: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<ICategoryItemShowAllProps>
>> = props => {
  const { t } = useContext(AppContext);
  const topLevel = props.item;

  return (
    <SubLevelItemShowAll key="show-all">
      {topLevel.externalUri && (
        <SubLevelLink as="a" href={topLevel.externalUri}>
          {t('category', 'subcategories.show-all')}
        </SubLevelLink>
      )}

      {!topLevel.externalUri && (
        <SubLevelLink
          to={props.linkToItem(topLevel)}
          onClick={() => trackClick(topLevel, SHOW_ALL_LINK)}
        >
          {t('category', 'subcategories.show-all')}
        </SubLevelLink>
      )}
    </SubLevelItemShowAll>
  );
};

interface ICategoryItemShowAllProps {
  item: CategoryTreeItem;
  linkToItem: (item: CategoryTreeItem) => string;
}

export default CategoryItemShowAll;
